/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PointsStrictHttpResponse } from '../../points-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ActiveLeagueModel } from '../../models/active-league-model';

export interface ConsumerGameTokenGet$Params {
}

export function consumerGameTokenGet(http: HttpClient, rootUrl: string, params?: ConsumerGameTokenGet$Params, context?: HttpContext): Observable<PointsStrictHttpResponse<ActiveLeagueModel>> {
  const rb = new RequestBuilder(rootUrl, consumerGameTokenGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PointsStrictHttpResponse<ActiveLeagueModel>;
    })
  );
}

consumerGameTokenGet.PATH = '/Consumer/GameToken';
